import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core';
import { Subscription } from 'rxjs';

import { SubCategoryService } from '@app/core/products/services/subcategory.service';

@Component({
  selector: 'filter-sub-category',
  templateUrl: './filter-sub-category.component.html',
  styleUrls: ['./filter-sub-category.component.scss'],
})
export class FilterSubCategoryComponent implements OnInit {
  constructor(public subCategoryService :SubCategoryService) {}

  @Input() value :number[];
  @Input() categoryIds :number[];
  @Input() label :string;
  @Output() changeSubCategory :EventEmitter<number[]> = new EventEmitter<
    number[]
  >();
  unsubscribeSubCategories :Subscription;
  subCategories :any[] = [];
  filteredSubCategories :any[] = [];

  ngOnInit() :void {
    this.loadSubCategories();
  }

  onChange() {
    this.changeSubCategory.emit(this.value);
  }

  ngOnDestroy() :void {
    if (this.unsubscribeSubCategories) {
      this.unsubscribeSubCategories.unsubscribe();
    }
  }

  ngOnChanges(changes :SimpleChanges) :void {
    if (changes.categoryIds) {
      this.filterSubCateogries(this.subCategories);
    } else {
      this.filteredSubCategories = this.subCategories;
    }
  }

  private loadSubCategories() :void {
    this.subCategoryService.get();
    this.unsubscribeSubCategories =
      this.subCategoryService.allSubCategories$.subscribe((subCategories :any) => {
        this.subCategories = subCategories;
        this.filterSubCateogries(subCategories);
      });
  }

  private filterSubCateogries(subCategories :any[]) :void {
    this.filteredSubCategories = subCategories.filter((subCategories) =>
      this.categoryIds?.length > 0
        ? this.categoryIds.includes(subCategories.category_id)
        : true,
    );
  }
}
